/**
 * Formats a numeric amount into a currency string with appropriate symbol.
 * @param {number} amount - The numeric value to format
 * @param {string} currencyCode - The ISO currency code (USD, EUR, GBP, etc.)
 * @returns {string} The formatted currency string
 */
export const formatCurrency = (amount, currencyCode = 'USD') => {
  if (amount === undefined || amount === null) return '—';
  
  const symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£'
  };

  const symbol = symbols[currencyCode?.toUpperCase()] || '$';
  return `${symbol}${Number(amount).toFixed(2)}`;
};

/**
 * Returns only the currency symbol for a given code.
 * @param {string} currencyCode 
 * @returns {string} symbol
 */
export const getCurrencySymbol = (currencyCode) => {
  const symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£'
  };
  return symbols[currencyCode?.toUpperCase()] || '$';
};
